import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Column, Page, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { openInNewTabProps, routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { ZapierTemplateDescription } from './ZapierTemplateDescription';
import { zapierTemplateIntegrationsByKey } from './zapierTemplateIntegrations';
import { getZapierTemplateIntegrationTexts } from './zapierTemplateIntegrationTexts';
export const GetZapierTemplatesPageTID = (parentTestId)=>getTestIds(parentTestId);
const { ZapierTemplatesPageTID } = GetZapierTemplatesPageTID();
function TemplateCard(param) {
    let { integration, templateKey, url, title, buttonLabel } = param;
    return /*#__PURE__*/ _jsx(Card, {
        bi: {
            name: 'zapier_template_card',
            data: {
                integration: integration.key,
                template: templateKey
            }
        },
        testId: ZapierTemplatesPageTID.TemplateCard(integration.key, templateKey),
        autoHeight: true,
        padding: "m",
        children: /*#__PURE__*/ _jsxs(Row, {
            justifyContent: "space-between",
            alignItems: "center",
            gap: 16,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    weight: "normal",
                    children: title
                }),
                /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                    bi: {
                        name: 'use_zapier_template',
                        data: {
                            integration: integration.key,
                            template: templateKey
                        }
                    },
                    size: "small",
                    as: "a",
                    href: url
                }, openInNewTabProps), {
                    testId: ZapierTemplatesPageTID.UseTemplate(integration.key, templateKey),
                    children: buttonLabel
                }))
            ]
        })
    });
}
function ZapierTemplatesPageContent(param) {
    let { integration } = param;
    const { t: zapierTemplatesTexts } = useLocaleKeys('integrations.apps.zapierTemplates');
    const navigate = useNavigate();
    const texts = getZapierTemplateIntegrationTexts(zapierTemplatesTexts, integration.i18nKey);
    return /*#__PURE__*/ _jsx(Page, {
        testId: ZapierTemplatesPageTID.Root(integration.key),
        header: texts.title(),
        subheader: /*#__PURE__*/ _jsx(ZapierTemplateDescription, {
            integration: integration
        }),
        fullWidthSubheader: true,
        onClickBack: ()=>navigate(routes.availableApps),
        children: /*#__PURE__*/ _jsx(Column, {
            gap: 12,
            alignItems: "stretch",
            children: integration.templates.map((template)=>/*#__PURE__*/ _jsx(TemplateCard, {
                    integration: integration,
                    templateKey: template.key,
                    url: template.url,
                    title: texts.templateTitle(template.key),
                    buttonLabel: zapierTemplatesTexts.useThisTemplate()
                }, template.key))
        })
    });
}
export function ZapierTemplatesPage() {
    const { integrationKey } = useParams();
    const integration = integrationKey ? zapierTemplateIntegrationsByKey[integrationKey] : undefined;
    if (!integration) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: routes.availableApps,
            replace: true
        });
    }
    return /*#__PURE__*/ _jsx(ZapierTemplatesPageContent, {
        integration: integration
    });
}
